import { useStoreSelector } from '@hook/store/store.hooks';

export const useConsumerCredentials = () => useStoreSelector((state) => state.credentials);
